import { useEffect } from 'react';
import { useProductStore } from '../store/productStore';

export function useProducts() {
  const { products, categories, featuredProducts, promoProducts, bannerProducts, loading, error, loadProducts } = useProductStore();

  useEffect(() => {
    if (products.length === 0) loadProducts();
  }, [products.length, loadProducts]);

  return { products, categories, featuredProducts, promoProducts, bannerProducts, loading, error, loadProducts };
}
